module.exports = __webpack_public_path__ + "img/CNC加工中心3.99ab022a.jpg";